export const LAUNCHER_CONTENT_STATE = {
  FIRST_CHAT: 'firstChat',
  MAIN_COVER: 'mainCover',
}

export const HELP_TAB_STATE = {
  FAQ_LIST: 'FAQ_LIST',
  FAQ_DETAIL: 'FAQ_DETAIL',
}

export const MESSENGER_TAB_STATE = {
  DEPARTMENTS: 'DEPARTMENTS',
  CHAT: 'CHAT',
}
